export default class Module {

    /**
     * @type string
     */
    nameInstance = ''

    /**
     * @type string
     */
    SELECTOR = ''

    /**
     * @type string
     */
    ATTR_NAME = ''

    /**
     * @type boolean
     */
    INIT_WITHOUT_CHILD = true

    /**
     * @type Object
     */
    settings = {}

    // constructor(element, settings) {
    //     this._constructor(element, settings)
    // }

    // Public Methods
    getNameInstance() {
        if(!this.nameInstance){
            throw new Error('Реализуйте: установите уникальное название экземпляра в поле nameInstance')
        }
        return this.nameInstance;
    }
    getNewModule(element){
        return new Module(element)
    }
    destroy() {
        throw new Error('Реализуйте: разрешение текущего экземпляра')
    }
    initAll(container) {
        let modules = []
        if(this._initAllOne(container)) {
            // Контейнер и есть нужный элемент

            modules.push(this.getNewModule(container))
            if(this.INIT_WITHOUT_CHILD){
                return modules
            }
        }

        container = container || document

        let elements = container.querySelectorAll(this.SELECTOR)
        for (let i = 0; i < elements.length; i++) {
            modules.push(this.getNewModule(elements[i]))
        }
        return modules
    }
    destroyAll(container) {
        let nameInstance = this.getNameInstance()

        if(container && container[nameInstance]) {
            // Контейнер и есть нужный элемент
            container[nameInstance].destroy();
            if(this.INIT_WITHOUT_CHILD){
                return
            }
        }

        if(!this.SELECTOR) {
            return;
        }

        container = container || document

        let elements = container.querySelectorAll(this.SELECTOR)
        for (let i = 0; i < elements.length; i++) {
            elements[i][nameInstance] && elements[i][nameInstance].destroy();
        }
    }
    // Private Methods
    _initAllOne(container){
        return container && container.hasAttribute(this.ATTR_NAME);
    }
    _implementation() {
        throw new Error('Реализуйте: вашу логику, после всех настроек')
    }
    _isUseElement(element) {
        return element && element.hasAttribute(this.ATTR_NAME)
    }
    _initSettings(element, settings) {
        throw new Error('Реализуйте: установку настроек текущего экземпляра')
        this.settings = settings
    }
    _constructor(element, settings) {
        this._destroyByNameInstance(element, this.getNameInstance())

        this._initSettings(element, settings);

        this._destroyByNameInstance(element, this.getNameInstance())

        this._initElement(element)

        this._implementation()
    }
    _destroyByNameInstance(element, name) {
        this.element && this.element[name] && this.element[name].destroy()
        element && element[name] && element[name].destroy()
    }
    _initElement(element){
        if(this._isUseElement(element)){
            let nameInstance = this.getNameInstance()
            element[nameInstance] = this;
            this.element = element;
        }
    }
    _on(element, event, callback, name) {
        if(element){
            this._off(element, event, callback, name)
            element.addEventListener(event, callback);
            if(name) {
                element[name] = callback
            }
        }
    }
    _off(element, event, callback, name) {
        if(element){
            if(name){
                element.removeEventListener(event, element[name]);
            } else {
                element.removeEventListener(event, callback);
            }
        }
    }
}
